import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { Subscription, filter } from 'rxjs'
import { EnterpriseContextService } from '../../../services/enterprise-context.service'
import { AuthenticationService } from '../../../services/authentication.service'
import { EnterpriseConfig } from '../../../config/enterprise.config'

@Component({
    selector: 'app-enterprise-admin-bar',
    templateUrl: './enterprise-admin-bar.component.html',
    styleUrls: ['./enterprise-admin-bar.component.scss'],
})
export class EnterpriseAdminBarComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = []
    
    currentEnterprise: EnterpriseConfig | null = null
    availableEnterprises: EnterpriseConfig[] = []
    currentRoute: string = ''
    
    // Enterprise menu items - order: Dashboard, Portfolios, Buildings, Subscriptions, Parkers, Invoices, Accounts, Settings
    menuItems = [
        { label: 'Dashboard', route: '/admin/dashboard', icon: 'fa-solid fa-chart-line' },
        { label: 'Portfolios', route: '/admin/merchants', icon: 'fa-solid fa-briefcase' },
        { label: 'Buildings', route: '/admin/parkings', icon: 'fa-solid fa-building' },
        { label: 'Map', route: '/admin/parking-map', icon: 'fa-solid fa-map-location-dot' },
        { label: 'Subscriptions', route: '/admin/subscriptions', icon: 'fa-solid fa-file-contract' },
        { label: 'Parkers', route: '/admin/parkers', icon: 'fa-solid fa-users' },
        { label: 'Invoices', route: '/admin/invoices', icon: 'fa-solid fa-file-invoice-dollar' },
        { label: 'Accounts', route: '/admin/accounts', icon: 'fa-solid fa-money-bill-transfer' },
        { label: 'Settings', route: '/admin/enterprise-settings', icon: 'fa-solid fa-cog' },
    ]

    constructor(
        public enterpriseContext: EnterpriseContextService,
        public authService: AuthenticationService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.availableEnterprises = this.enterpriseContext.getAvailableEnterprises()
        
        // Subscribe to enterprise changes
        const entSub = this.enterpriseContext.currentEnterprise$.subscribe((enterprise) => {
            this.currentEnterprise = enterprise
        })
        this.subscriptions.push(entSub)
        
        // Track current route for active state
        this.currentRoute = this.router.url
        const routeSub = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            this.currentRoute = event.url
        })
        this.subscriptions.push(routeSub)
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe())
    }

    onEnterpriseSelect(enterpriseKey: string | null): void {
        this.enterpriseContext.setEnterprise(enterpriseKey)
    }

    get backgroundColor(): string {
        if (this.currentEnterprise) {
            return this.currentEnterprise.primaryColor
        }
        return '#6c757d' // Gray for "All Enterprises"
    }

    get textColor(): string {
        // For light backgrounds, use dark text
        if (this.currentEnterprise?.headerLight) {
            return '#212529'
        }
        return '#ffffff'
    }

    get isEnterpriseSelected(): boolean {
        return this.currentEnterprise !== null
    }

    get canSwitchEnterprise(): boolean {
        return this.enterpriseContext.canSwitchEnterprise
    }

    get isEnterpriseManager(): boolean {
        return this.authService.isEnterpriseManager
    }

    isRouteActive(route: string): boolean {
        return this.currentRoute.startsWith(route)
    }

    navigateTo(route: string): void {
        this.router.navigate([route])
    }
}

